module.exports = __webpack_public_path__ + "img/Artboard 12.dd1c588f.svg";